export function LogoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      fill="none"
      viewBox="0 0 13 16"
    >
      <path
        fill="#FF4D4F"
        d="M.35 3.722a.65.65 0 101.3 0H.35zM8.857 8.65a.65.65 0 100-1.3v1.3zM.54 7.54a.65.65 0 000 .92l4.137 4.136a.65.65 0 00.92-.919L1.918 8l3.677-3.677a.65.65 0 00-.919-.92L.54 7.54zm1.11-3.818V2.556H.35v1.166h1.3zm.921-2.072h7.858V.35H2.57v1.3zm8.779.906v10.888h1.3V2.556h-1.3zm-.921 11.794H2.57v1.3h7.858v-1.3zm-8.779-.906v-1.166H.35v1.166h1.3zm.921.906a.914.914 0 01-.921-.906H.35c0 1.225 1 2.206 2.221 2.206v-1.3zm8.779-.906a.914.914 0 01-.921.906v1.3c1.22 0 2.221-.981 2.221-2.206h-1.3zM10.429 1.65c.515 0 .921.412.921.906h1.3c0-1.225-1-2.206-2.221-2.206v1.3zm-8.779.906c0-.494.406-.906.921-.906V.35C1.351.35.35 1.331.35 2.556h1.3zM8.857 7.35H1v1.3h7.857v-1.3z"
      ></path>
    </svg>
  );
}
